import { format } from "date-fns"

function timeZoneOffset(date: Date, timeZone: string): number {
  if (isNaN(date.getTime())) return 0

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).formatToParts(date)

  const lookup = (type: Intl.DateTimeFormatPartTypes): number =>
    parseInt(parts.find((part) => part.type === type)?.value ?? "0", 10)

  const rawHour = lookup("hour")
  const hour = rawHour === 24 ? 0 : rawHour
  const asUtc = Date.UTC(lookup("year"), lookup("month") - 1, lookup("day"), hour, lookup("minute"), lookup("second"))

  return asUtc - date.getTime()
}

export function dateAtStartOfDayInTimeZone(date: Date, timeZone?: string | null): Date {
  if (!timeZone || isNaN(date.getTime())) return date

  const utcGuess = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0))
  return new Date(utcGuess.getTime() - timeZoneOffset(utcGuess, timeZone))
}

// All-day recurrences send dates as bare "YYYY-MM-DD" strings so the backend can
// anchor them in the book's timezone without having to recover a calendar date
// from a moment-in-time. Timed recurrences keep sending an ISO instant so the
// user's selected time of day survives.
export function recurrenceDate(date: Date, allDay: boolean): string {
  return allDay ? format(date, "yyyy-MM-dd") : date.toISOString()
}
